import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
export function GuaranteeSection() {
  return <section className="py-20 px-5 max-w-3xl mx-auto text-center pt-[20px] pb-[20px]" data-id="element-81">
      <FadeInUp data-id="element-82">
        <div className="flex justify-center mb-8" data-id="element-83">
          <div className="bg-zen-beige p-6 rounded-full" data-id="element-84">
            <ShieldCheckIcon className="w-16 h-16 text-pistachio" data-id="element-85" />
          </div>
        </div>
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-dark mb-6" data-id="element-86">
          7 Días de Garantía Paz
        </h2>
        <p className="text-xl text-slate-dark/80 leading-relaxed max-w-2xl mx-auto" data-id="element-87">
          Si en una semana tu perro no está más tranquilo, te devolvemos el 100%
          de tu dinero. Sin preguntas, sin complicaciones. Tu tranquilidad y la
          de tu mascota están garantizadas.
        </p>
      </FadeInUp>
    </section>;
}